import NumberFormat from 'react-number-format'
import PropTypes from 'prop-types'

const CampaignAfter = ({ after }) => (
  <>
    {after.name && (
      <tr>
        <th scope="row">이름</th>
        <td>
          <div className="inner_cell">{after.name}</div>
        </td>
      </tr>
    )}
    {after.conversionTracking && (
      <tr>
        <th scope="row">전환추적</th>
        <td>
          <div className="inner_cell">{after.conversionTracking}</div>
        </td>
      </tr>
    )}
    {after.traceUrlYn && (
      <tr>
        <th scope="row">추적URL</th>
        <td>
          <div className="inner_cell">
            {after.traceUrlYn === 'Y' ? '설정' : '미설정'}
          </div>
        </td>
      </tr>
    )}
    {after.dailyBudgetAmount && (
      <tr>
        <th scope="row">일예산</th>
        <td>
          <div className="inner_cell">
            <NumberFormat
              value={after.dailyBudgetAmount}
              displayType="text"
              thousandSeparator
            />
            <span className="desc_won">원</span>
          </div>
        </td>
      </tr>
    )}
  </>
)
export default CampaignAfter
CampaignAfter.propTypes = {
  after: PropTypes.shape({
    name: PropTypes.string,
    conversionTracking: PropTypes.string,
    traceUrlYn: PropTypes.string,
    dailyBudgetAmount: PropTypes.number,
  }),
}
